import React, { useState } from 'react';
import { XCircle } from 'lucide-react';

interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export default function DisclaimerModal({ isOpen, onClose, onProceed }: DisclaimerModalProps) {
  const [isChecked, setIsChecked] = useState(false);
  
  if (!isOpen) return null;

  const handleProceed = () => {
    if (isChecked) {
      onProceed();
    }
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md relative">
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <XCircle className="w-6 h-6" />
        </button>
        
        <div className="text-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Important Notice</h2>
        </div>
        
        <div className="mb-6">
          <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg mb-4">
            <p className="text-amber-800 font-medium mb-2">Disclaimer</p>
            <p className="text-gray-700 mb-3">
              The market price estimates provided by The Fuel Central are for informational and entertainment purposes only. 
              Our valuations are based on proprietary algorithms and available market data, but should not be relied 
              upon for making financial or business decisions.
            </p>
            <p className="text-gray-700 mb-3">
              The Fuel Central does not guarantee the accuracy of these estimates and expressly disclaims any liability 
              for any actions taken based on these valuations. Professional appraisals and due diligence should be 
              conducted before making any investment, purchase, or sale decisions.
            </p>
            <p className="text-gray-700">
              The accuracy of the valuation depends on the accuracy and completeness of the information you provide.
            </p>
          </div>
          
          <div className="flex items-start mb-4">
            <div className="flex items-center h-5">
              <input
                id="disclaimer-checkbox"
                type="checkbox"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                required
              />
            </div>
            <label htmlFor="disclaimer-checkbox" className="ml-2 text-sm text-gray-700">
              I understand that the valuation provided is for informational purposes only and should not be used as the sole basis for business decisions.
            </label>
          </div>
        </div>
        
        <div className="flex justify-center">
          <button
            onClick={handleProceed}
            disabled={!isChecked}
            className={`px-6 py-2 rounded-lg ${
              isChecked
                ? 'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
}
